import type { Task } from '@/lib/gantt/src'
import { httpClient } from '@/services/http/httpClient'

export type UpdateProjectByGantt = Pick<Task, 'start' | 'end'> & {
  portfolioId: string
  projectId: string
}

export async function updateProjectByGantt({
  portfolioId,
  projectId,
  start,
  end,
}: UpdateProjectByGantt) {
  return await httpClient.put(`/projects/portfolios/${portfolioId}/gantt`, {
    start,
    end,
    projectId,
  })
}
